import { TextOneOrMany } from "../../utils/index.jsx";
import InitialesLogo from "../UI/InitialesLogo";
import Card from "../UI/Card";
import DisplayName from "../UI/DisplayName";

export default function SignatairesCard({ profiles, bailleur, caution }) {
  return (
    <Card className={"padding10"}>
      <p className={"cardTitle text-center"}>
        <TextOneOrMany
          one={`Signataire ${
            bailleur ? "bailleur" : caution ? "caution" : "locataire"
          }`}
          many={`Signataires ${
            bailleur ? "bailleurs" : caution ? "cautions" : "locataires"
          }`}
          number={profiles?.length}
        />
      </p>
      {profiles?.map((profile, i) => (
        <div className={"flex align-items-center marginT10"} key={i}>
          <InitialesLogo
            shape={"rond"}
            nom={profile.nom}
            prenom={profile.prenom}
          />
          <div className={"marginL10"}>
            <p className={"primaryText"}>
              <DisplayName profile={profile} />
            </p>
            <p>{profile.mail}</p>
          </div>
        </div>
      ))}
    </Card>
  );
}
